<template>
  <v-container fluid class="full-height">
    <v-row class="fill-height">
      <v-col
        cols="12"
        sm="10"
        offset-sm="1"
        md="8"
        offset-md="2"
        lg="6"
        offset-lg="3"
        xl="4"
        offset-xl="4"
      >
        <v-card class="mb-6" outlined>
          <validation-observer ref="MembershipProfileFormValidator">
            <v-card-title>
              パスワード設定
            </v-card-title>

            <!-- ログインID -->
            <v-card-text>
              <div class="subtitle-2">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|login_id|min:4|max:255"
                  class="requiredMark"
                  name="ログインID"
                >
                  <v-text-field
                    v-model="user.login_id"
                    :error-messages="errors"
                    autocomplete="off"
                    dense
                    hide-details="auto"
                    label="ログインID"
                    outlined
                    persistent-placeholder
                  />
                </validation-provider>
              </div>
            </v-card-text>
            <!-- /ログインID -->

            <v-card-text>
              <div class="subtitle-2">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|password"
                  vid="password"
                  name="パスワード"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="user.password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :error-messages="errors"
                    :type="showPassword ? 'text' : 'password'"
                    autocomplete="new-password"
                    dense
                    label="パスワード"
                    hide-details="auto"
                    outlined
                    persistent-placeholder
                    @click:append="showPassword = !showPassword"
                  />
                </validation-provider>
              </div>
            </v-card-text>

            <v-card-text>
              <div class="subtitle-2">
                <validation-provider
                  v-slot="{ errors }"
                  class="requiredMark"
                  name="パスワード（確認用）"
                  rules="required|confirmed:password"
                >
                  <v-text-field
                    v-model="user.password_confirmation"
                    :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :error-messages="errors"
                    :type="showConfirmPassword ? 'text' : 'password'"
                    autocomplete="new-password"
                    dense
                    label="パスワード（確認用）"
                    outlined
                    persistent-placeholder
                    @click:append="showConfirmPassword = !showConfirmPassword"
                  />
                </validation-provider>
              </div>
            </v-card-text>

            <v-card-text>
              <v-row
                align="center"
                justify="center"
                class="fill-height"
              >
                <v-card outlined>
                  <v-card-text>
                    <div class="subtitle-2">
                      ログインID: 半角英数記号4文字以上、大文字小文字区別なし<br>
                      パスワード: 半角8~12文字 英小文字・大文字・数字をそれぞれ1種類以上
                    </div>
                  </v-card-text>
                </v-card>
              </v-row>
            </v-card-text>

            <v-card-text>
              <v-row dense>
                <v-col
                  cols="12"
                  class="text-center"
                >
                  <v-btn
                    color="primary"
                    :block="$vuetify.breakpoint.mdAndDown"
                    @click="toNext"
                  >
                    <v-icon class="mr-2">
                      mdi-account-edit-outline
                    </v-icon>
                    次へ
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </validation-observer>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'MembershipProfileForm',
  components: {
  },
  mixins: [],
  props: {
    user: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data () {
    return {
      showPassword: false,
      showConfirmPassword: false,
    }
  },
  methods: {
    toNext () {
      let $self = this
      this.$refs.MembershipProfileFormValidator.validate().then((result) => {
        if (result) {
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation () {
      this.$emit('toNextStep')
    }

  },

}
</script>

<style scoped lang="scss">
</style>
